import { render, staticRenderFns } from "./relevanceId.vue?vue&type=template&id=005faac3&scoped=true&"
import script from "./relevanceId.vue?vue&type=script&lang=js&"
export * from "./relevanceId.vue?vue&type=script&lang=js&"
import style0 from "./relevanceId.vue?vue&type=style&index=0&id=005faac3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005faac3",
  null
  
)

export default component.exports